import Vue from 'vue';
import Component from 'vue-class-component';
import EdListUserRequestsComponent from '@/app/private/user-requests/components/ed-list-user-requests/ed-list-user-requests.component.vue'
import { USER_REQUESTS_TABS } from '../../values/user-requests.values'
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    EdListUserRequests: EdListUserRequestsComponent
  }
})
export default class UserRequestsView extends Vue {

  public tab: any = 0;
  public tabs = USER_REQUESTS_TABS;

  get tabsOptionHeader(): {id: number, label: string, ariaControls: string}[] {
    return [
      { id: 0, label: `${this.$t('userRequests.approveUsers')}`,    ariaControls: 'given-invitations' },
      { id: 1, label: `${this.$t('userRequests.approvedHistory')}`, ariaControls: 'received-invitations' },
      { id: 2, label: `${this.$t('userRequests.deniedHistory')}`,   ariaControls: 'received-invitations' },
    ];
  }

  public tabsOptionContent = [
    { id: 0, component: EdListUserRequestsComponent, props: {tab: USER_REQUESTS_TABS.USER_REQUESTS} },
    { id: 1, component: EdListUserRequestsComponent, props: {tab: USER_REQUESTS_TABS.APPROVED_HISTORY} },
    { id: 2, component: EdListUserRequestsComponent, props: {tab: USER_REQUESTS_TABS.DENIED_HISTORY} },
  ]

  @Watch('tab')
  resetLists() {
    this.$UserRequests.Store.resetUserRequests();
  }

}